module.exports = __webpack_public_path__ + "static/media/Onboarding-BuscaInteligente2x.db44d229.png";